import screens from 'constants/screens';
import { FC, ReactNode } from 'react';

type PageWithTabsAsideWrapperProps = {
  children: ReactNode;
  screenShowAside?: string;
};

const defaultScreenShowAside = screens.XL;

const PageWithTabsAsideWrapper: FC<PageWithTabsAsideWrapperProps> = ({
  children,
  screenShowAside = defaultScreenShowAside,
}) => (
  <div
    className={`card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-${screenShowAside} toggle-screen-${screenShowAside} content-active`}
    data-content="userAside"
    data-toggle-body="true"
    data-toggle-overlay="true"
  >
    <div className="card-inner-group">
      <div className="simplebar-wrapper">
        <div className="simplebar-height-auto-observer-wrapper">
          <div className="simplebar-height-auto-observer" />
        </div>
        <div className="simplebar-mask">
          <div className="simplebar-offset">
            <div className="simplebar-content-wrapper">
              <div className="simplebar-content">{children}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="simplebar-placeholder" />
    </div>
    <div className="simplebar-track simplebar-horizontal">
      <div className="simplebar-scrollbar" />
    </div>
    <div className="simplebar-track simplebar-vertical">
      <div className="simplebar-scrollbar" />
    </div>
  </div>
);

export default PageWithTabsAsideWrapper;
